import React from "react";
import { IconType } from "react-icons";

interface ProviderLogoProps {
    brandColor: string;
    icon: IconType;
    logoBgColor?: string;
}

export function ProviderLogo({ brandColor, icon: Icon, logoBgColor }: ProviderLogoProps) {
    const bgColor = logoBgColor ?? brandColor;
    const iconColor = logoBgColor ? brandColor : "white";

    return (
        <div
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
            style={{ backgroundColor: bgColor }}
        >
            {Icon({ className: "h-5 w-5", style: { color: iconColor } })}
        </div>
    );
}
